<template>
    <div id="report" style="height:100%;">
        <div class="table_searchbar">
            <el-row>
                <el-col :span="W?5:6">
                    <div class @keydown.enter="clickSearch(1,'setpage')">
                        <span class="title">订单号：</span>
                        <el-input :style="W?{'max-width':'180px'}:{'max-width':'160px'}" size="small"
                            v-model="searchForm.orderCode" maxlength="100" placeholder="订单号"></el-input>
                    </div>
                </el-col>
                <el-col :span="W?5:6">
                    <div class @keydown.enter="clickSearch(1,'setpage')">
                        <span class="title">物料编码：</span>
                        <el-input :style="W?{'max-width':'180px'}:{'max-width':'160px'}" size="small"
                            v-model="searchForm.materialCode" maxlength="100" placeholder="物料编码"></el-input>
                    </div>
                </el-col>
                <el-col :span="W?5:6">
                    <div class @keydown.enter="clickSearch(1,'setpage')">
                        <span class="title">物料名称：</span>
                        <el-input :style="W?{'max-width':'180px'}:{'max-width':'160px'}" size="small"
                            v-model="searchForm.materialName" maxlength="100" placeholder="物料名称"></el-input>
                    </div>
                </el-col>
                <el-col :span="W?5:6">
                    <div class @keydown.enter="clickSearch(1,'setpage')">
                        <span class="title">处理状态：</span>
                        <el-select :style="W?{'max-width':'180px'}:{'max-width':'120px'}" clearable
                            v-model="searchForm.exceptionStatus" size="small" maxlength="16" placeholder="处理状态">
                            <el-option v-for="item in statusOptions" :key="item.id" :value="item.id" :label="item.name">
                            </el-option>
                        </el-select>
                    </div>
                </el-col>
            </el-row>
            <el-row style="margin-top:20px">
                <!-- 此列暂无数据 -->
                <!-- <el-col :span="W?5:7">
          <div class @keydown.enter="clickSearch(1,'setpage')">
            <span class="title">异常状态：</span>
            <el-select
              :style="W?{'max-width':'180px'}:{'max-width':'160px'}"
              clearable
              v-model="searchForm.exceptionType"
              size="small"
              maxlength="16"
              placeholder="异常状态"
            >
              <el-option
                v-for="item in exceptionTypeOptions"
                :key="item.id"
                :value="item.id"
                :label="item.label"
              ></el-option>
            </el-select>
          </div>
        </el-col>-->
                <el-col :span="W?5:7">
                    <!-- <div class @keydown.enter="clickSearch(1,'setpage')">
            <span class="title">处理状态：</span>
            <el-select
              :style="W?{'max-width':'180px'}:{'max-width':'160px'}"
              clearable
              v-model="searchForm.exceptionStatus"
              size="small"
              maxlength="16"
              placeholder="处理状态"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.id"
                :value="item.id"
                :label="item.name"
              ></el-option>
            </el-select>
          </div>-->
                </el-col>
                <el-col :span="W?22:24">
                    <div style="text-align:right">
                        <!-- 测试区域 -->
                        <!-- <el-button type="info" size="mini" @click="showDig">生产异常</el-button> -->
                        <!-- <el-button type="primary" size="mini">跳转</el-button> -->
                        <!-- <router-link to="/tiaozhuan"><el-button type="primary" size="mini">跳转</el-button></router-link> -->
                        <!-- 测试区域 -->

                        <el-button icon="el-icon-search" size="mini" type="primary" @click="clickSearch(1,'setpage')">查询
                        </el-button>
                        <el-button style="margin-left: 9px;" icon="el-icon-refresh" size="mini" @click="clearSearch">重置
                        </el-button>
                    </div>
                </el-col>
            </el-row>
        </div>
        <el-row class="tab">
            <el-row class="table-wrap" style="margin-top:10px">
                <!--  -->
                <div style="margin-top:10px;">
                    <el-table :data="orderList" class="table_data y_Public_table">
                        <el-table-column prop="materialName" label="订单号">
                            <template slot-scope="scope">
                                <el-tooltip class="item" effect="dark" :content="scope.row.orderCode"
                                    placement="top-start">
                                    <div class="y_clamp">
                                        <div>{{scope.row.orderCode}}</div>
                                    </div>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column prop="productionBatchCode" label="批次号"></el-table-column>
                        <el-table-column prop="orderState" :formatter="parseOrderState" label="订单状态"></el-table-column>
                        <el-table-column prop="materialCode" label="物料编码"></el-table-column>
                        <!-- <el-table-column   prop="productionProcess" label="生产进度" :formatter="parseRatio" ></el-table-column> -->
                        <el-table-column prop="materialName" label="物料名称" show-overflow-tooltip></el-table-column>

                        <!-- 此列暂无数据 -->
                        <!-- <el-table-column prop="materialName" label="计划数量">
                <template slot-scope="scope">
                    <span>{{scope.row.id}}</span>
                </template>
            </el-table-column>-->

                        <!-- <el-table-column prop="materialName" label="异常状态">
                 <template slot-scope="scope">
                    <span v-if="scope.row.id!=1">节拍异常</span>
                    <span v-else>无异常</span>
                </template>
            </el-table-column>-->
                        <el-table-column prop="materialName" label="是否处理">
                            <template slot-scope="scope">
                                <span v-if="scope.row.isDispose==0">未处理</span>
                                <span v-else-if="scope.row.isDispose==1">已处理</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <el-button v-if="permission.btn_productionFlow_getDetail" @click="getDetails(scope.row)"
                                    type="text">查看</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-row>
            <div class="page" v-if="page.isShow">
                <div class="total_page">
                    <span>共{{page.total}}条 10条/页</span>
                </div>
                <div style="margin-top:10px;text-align:right; margin-bottom:20px;">
                    <el-pagination background layout="prev, pager, next" :total="page.total"
                        @current-change="pageChange" :current-page="page.tableCurrentPage"></el-pagination>
                </div>
            </div>
        </el-row>

        <!-- 查看详情开始 -->

        <!-- 查看详情结束 -->

        <!-- 生产流转异常详情开始 -->
        <el-dialog title="流转异常" @close="cancelViewDialog" :visible.sync="ProDialogVisible"
            :width="span==5?'59.5%':'68%'" center :close-on-click-modal="false">
            <el-row :gutter="20" style="margin-bottom:20px">
                <el-col :span="8">
                    <span class="title">订单号：</span>
                    <span>{{detailFrom.orderCode}}</span>
                </el-col>
                <el-col :span="8">
                    <span class="title">批次号：</span>
                    <span>{{detailFrom.productionBatchCode}}</span>
                </el-col>
                <!-- <el-col :span="8">
          <span class="title">生产数量：</span>
          <span>{{detailFrom.materialModel}}</span>
        </el-col>-->
                <el-col :span="8">
                    <span class="title">物料编码：</span>
                    <span>{{detailFrom.materialCode}}</span>
                </el-col>
            </el-row>
            <el-row :gutter="20" :style="addForm.exceptionType==2?{marginBottom:'20px'}:{}">
                <!-- <el-col :span="8">
          <span class="title">物料编码：</span>
          <span>{{detailFrom.materialCode}}</span>
        </el-col>-->
                <el-col :span="8">
                    <span class="title">物料名称：</span>
                    <span>{{detailFrom.materialName}}</span>
                </el-col>
                <el-col :span="8">
                    <span class="title">物料类型：</span>
                    <!-- <span>{{detailFrom.itemType==1?'零件':''}}</span> -->
                    <span v-if="detailFrom.itemType==0">产品</span>
                    <span v-else-if="detailFrom.itemType==1">零件</span>
                    <span v-else-if="detailFrom.itemType==2">原材料</span>
                </el-col>
            </el-row>

            <!-- 表格 -->
            <!-- <el-row> -->
            <el-table :row-style="isRowStyle" :data="detailList" style="width: 100%;margin-top:30px;"
                :cell-style="isStyle">
                <el-table-column align="center" type="index" label="序号" :width="W? '50'+'px':'45'+'px'">
                </el-table-column>
                <el-table-column align="center" prop="procedureName" label="工序名称" :width="W? '100'+'px':'80'+'px'">
                </el-table-column>
                <el-table-column align="center" prop="actualStartTime" :formatter="parseOrderDate" label="实际开始时间"
                    :width="W? '180'+'px':'135'+'px'"></el-table-column>
                <el-table-column align="center" prop="actualEndTime" label="实际结束时间" :width="W? '180'+'px':'135'+'px'">
                    <template slot-scope="scope">
                        <span>{{scope.row.actualEndTime|date}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="actualProcessDuration" label="实际加工时长"
                    :width="W? '100'+'px':'95'+'px'">
                    <!-- <template slot-scope="scope">{{scope.row.actualProcessDuration}}分钟</template> -->
                    <template slot-scope="scope">
                        <!-- <span v-if="typeof(scope.row.actualProcessDuration)=='number'&&scope.row.actualProcessDuration>0">{{scope.row.actualProcessDuration}}分钟</span> -->
                        <span>{{scope.row.actualProcessDuration?scope.row.actualProcessDuration + '分钟':''}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="theoreticalDuration" label="理论时长"
                    :width="W? '100'+'px':'80'+'px'">
                    <!-- <template slot-scope="scope">{{scope.row.theoreticalDuration}}分钟</template> -->
                    <template slot-scope="scope">

                        <span>{{scope.row.theoreticalDuration?scope.row.theoreticalDuration+'分钟': '' }}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="articlesBeingProcessedCount" label="在制品数量"
                    :width="W? '100'+'px':'80'+'px'"></el-table-column>
                <el-table-column align="center" prop="lastReportTime" label="最后一次报工时间"
                    :width="W? '180'+'px':'135'+'px'">
                    <template slot-scope="scope">
                        <span>{{scope.row.lastReportTime|date}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="stagnateDuration" label="停滞时长" :width="W? '100'+'px':'92'+'px'">
                    <!-- <template slot-scope="scope">{{scope.row.stagnateDuration}}分钟</template> -->
                    <template slot-scope="scope">
                        <span>{{scope.row.stagnateDuration?scope.row.stagnateDuration+'分钟':''}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <!-- </el-row> -->
            <span slot="footer" style="margin-top:-10px">
                <!-- <el-button
          v-if="addForm.exceptionStatus=='未处理'"
          @click="dispose(addForm,addForm.exceptionType)"
          type="primary"
        >处 理</el-button>-->
                <el-button @click="closeProDialogVisible">关 闭</el-button>
            </span>
        </el-dialog>
        <!-- 生产流转异常详情结束 -->
    </div>
</template>

<script>
import CommonUtils from "../util/CommonUtils";
export default {
    name: "warning",
    data() {
        return {
            YmouserShow: null,
            searchCopy: {},
            viewDialogVisible: false,
            orderStatusOptions: [
                { id: 0, label: "未开始" },
                { id: 1, label: "已完成" },
                { id: 2, label: "已延期" },
                { id: 3, label: "已关闭" },
                { id: 4, label: '生产中' },
                { id: 5, label: '未排产' },
                { id: 6, label: '延期完成' },
            ],
            addForm: {},
            fristLoad: false,
            statusOptions: [
                { name: "未处理", id: 0 },
                { name: "已处理", id: 1 }
            ],
            tableData: [],
            page: {
                isShow: true,
                total: 0,
                currentPage: 1,
                pageSize: 10
            },
            W: false,
            searchForm: {
                exceptionStatus: null,
                orderCode: "",
                materialCode: "",
                exceptionType: null,
                materialName: ""
            },
            orderList: [],
            //   详情列表
            detailList: [],
            //   详情From
            detailFrom: [],
            //   生产流转异常详情对话框
            ProDialogVisible: false,
            //
            // 测试数据
            //
            permission: JSON.parse(localStorage.getItem("permission"))
        };
    },
    computed: {
        span() {
            return this.W ? 5 : 7;
        },
        warningType() {
            if (this.$store.state.warningType == 1) {
                this.$set(this.searchForm, "exceptionType", 2);

                this.search(1);
                this.$store.commit("changeWarningType", 0);
            }
            return this.$store.state.warningType;
        }
    },
    watch: {
        warningType(old, newValue) {
            log(old, newValue, "异常状态改变");
        }
    },
    created: function () {
        this.search();
        console.log(this.searchForm);
    },
    mounted: function () {
        let w = document.documentElement.clientWidth || document.body.clientWidth;
        w >= 1900 ? (this.W = true) : (this.W = false);
        window.onresize = () => {
            let w = document.documentElement.clientWidth || document.body.clientWidth;
            w >= 1900 ? (this.W = true) : (this.W = false);
        };
        this.init();
    },
    filters: {
        date(time) {

            return commonUtils.timestampToDate(time)
        }
    },
    methods: {
        //   parseOrderDate: function(time) {
        //   if (time != null) {
        //     let dateString = commonUtils.timestampToDate(time.actualEndTime);
        //     return dateString.substring();
        //   }
        // },lastReportTime
        parseOrderDate(rowData) {
            if (rowData.actualStartTime) {
                let dateString = commonUtils.timestampToDate(rowData.actualStartTime);
                return dateString;
            }
        },
        parseOrderState(rowData) {
            return (this.orderStatusOptions.find(item => item.id == rowData.orderState) || {}).label
        },

        //   parseOrderDate1(rowData) {
        //   if (rowData.lastReportTime) {
        //     let dateString = commonUtils.timestampToDate(rowData.lastReportTime);
        //     return dateString;
        //   }
        // },
        init: function () {
            this.search();
        },
        clickSearch: function (paage, type) {
            this.searchCopy = commonUtils.cloneObj(this.searchForm);
            if (type) {
                this.$set(this.page, "tableCurrentPage", 1);
            }
            //   console.log(this.searchForm);

            this.search(1);
        },
        pageChange(pageNum) {
            this.$set(this, "searchForm", commonUtils.cloneObj(this.searchCopy));
            this.search(pageNum);
        },
        //清空查询条件
        clearSearch() {
            (this.searchForm.exceptionStatus = null),
                (this.searchForm.orderCode = "");
            this.searchForm.materialCode = "";
            this.searchForm.exceptionType = null;
            this.searchForm.materialName = "";
        },
        search: function (pageNum) {
            console.log("search1");
            if (pageNum == null || pageNum instanceof KeyboardEvent) {
                pageNum = 1;
            }
            this.$set(this.page, "tableCurrentPage", pageNum);
            // 流转异常
            this.$RequestUtil.get({
                url: "/api/productionFlow/list",
                type: "sync",
                params: {
                    // 异常类型12
                    materialName: this.searchForm.materialName,
                    // 页码
                    pageNum: pageNum,
                    // 页/条
                    pageSize: this.page.pageSize,
                    // 处理状态
                    isDispose: this.searchForm.exceptionStatus,
                    // 订单号
                    orderCode: this.searchForm.orderCode,
                    // 物料编码
                    materialCode: this.searchForm.materialCode
                },
                success: res => {
                    if (res.code == 0) {
                        this.tableData = res.data;
                        this.page.total = res.totalPages;
                        if (res.totalPages == 0 && this.fristLoad) {
                            this.$message.warning("查询不到符合条件的数据");
                        }
                        this.fristLoad = true;
                        this.orderList = res.data;
                    } else {
                        this.$message.error(res.message || res.msg);
                    }
                }
            });
        },
        getDetails(scope) {
            const id = scope.id;
            this.detailFrom = scope;
            this.$RequestUtil.get({
                url: "api/productionFlow/getDetail",
                type: "sync",
                params: {
                    flowId: id
                },
                success: res => {
                    if (res.code == 0) {
                        //   赋值
                        this.detailList = res.data.detailList;
                    } else {
                        this.$message.error(res.message || res.msg);
                    }
                }
            });
            this.ProDialogVisible = true;
        },
        cancelViewDialog() {
            this.viewDialogVisible = false;
        },

        //
        showDig() {
            this.ProDialogVisible = true;
        },
        closeProDialogVisible() {
            this.ProDialogVisible = false;
        },
        //

        changeClass({ row, column, rowIndex, columnIndex }) {
            if (rowIndex == 2) {
                return "red";
            } else {
                return "";
            }
        },
        isStyle({ row, column, rowIndex, columnIndex }) {
            // log(row,row.id,)
            if (
                row.actualProcessDuration > row.theoreticalDuration &&
                columnIndex == 4
            ) {
                return {
                    backgroundColor: "#EE2C2C",
                    color: "black"
                };
            } else if (
                0 < row.stagnateDuration &&
                row.stagnateDuration <= 50 &&
                columnIndex == 8
            ) {
                return {
                    backgroundColor: "#FFD700",
                    color: "black"
                };
            } else if (row.stagnateDuration > 50 && columnIndex == 8) {
                return {
                    backgroundColor: "#EE2C2C",
                    color: "black"
                };
            }
        },
        isRowStyle({ row, rowIndex }) {
            if (rowIndex >= 0) {
                return {
                    lineHeight: ""
                };
            }
        }
        // tiaozhuan() {
        //   this.$router.push("/tiaozhuan");
        // }
    }
};
</script>

<style scoped>
.isRowStyle th {
    height: 30px;
}
.red {
    background-color: red;
}
.el-table-column {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
/* .warp{
    overflow: hidden;
    height: 100%;
    width: 100%;
    
} */
#report {
    overflow: hidden;
    overflow-y: auto;
    width: 100%;
    scrollbar-width: none;
}
#report::-webkit-scrollbar {
    display: none;
}
#report .title {
    font-size: 14px;
}
.search-input-row {
    margin-top: 10px;
}
.page {
    display: flex;
    justify-content: flex-end;
}
.total_page {
    margin-top: 16px;
    margin-right: 16px;
    color: #606266;
    font-size: 14px;
}
@media screen and (max-width: 1380px) {
    .page {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 30px;
    }
    .el-input {
        width: 100px;
    }
}
</style>
<style>
.el-table .el-table__body .rowbg {
    background: #ffffff !important;
}
.el-table .el-table__body .rowbg:hover > td {
    background: #ffffff !important;
}
/*  */
.marTop {
    margin-top: 30px;
}

/* .tabs .el-tabs__item{
    font-size:18px;
    text-align:left;
    width:112px;
}
.tabs .el-tabs__nav{
    width:100%;
    display:flex;
    justify-content: space-around;
}
.tabs .el-tabs__nav-wrap::after{
    height: 0;
}
.tabs .el-tabs__active-bar{
    width:72px;
    height: none;
} */
/* .tabs .el-tabs__nav-wrap::after{
    height: 0;
} */
/* .tabs  .el-tabs__active-bar{
    height: 0px;
}
.tabs  .is-active::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 2px;
    background-color: #409EFF;
    z-index: 1;

}
.tabs .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
    padding-left: 20px;
} */
</style>





// WEBPACK FOOTER //
// src/views/Productionflow.vue